import { useCallback, useMemo, useState } from 'react';
import { LIFECARE_TABS, LIFECARE_TAB_TYPES } from '@demandproai/shared';

const resolveTabLabel = ({ tab, plan }) => {
  const heading = plan?.[tab.key]?.title;
  if (typeof heading === 'string' && heading.trim()) return heading.trim();
  return tab.label;
};

const useLifecareStudioTabView = ({ plan } = {}) => {
  const [activeTabType, setActiveTabType] = useState(LIFECARE_TAB_TYPES.INFO);

  const tabs = useMemo(
    () =>
      LIFECARE_TABS.map((tab) => ({
        type: tab.tabType,
        label: resolveTabLabel({ tab, plan }),
      })),
    [plan]
  );

  const handleTabClick = useCallback((type) => {
    setActiveTabType(type);
  }, []);

  const activeTab = useMemo(
    () => LIFECARE_TABS.find((tab) => tab.tabType === activeTabType) || LIFECARE_TABS[0],
    [activeTabType]
  );

  return {
    tabs,
    activeTabType,
    activeTab,
    handleTabClick,
  };
};

export default useLifecareStudioTabView;
